import './static/css/master.css';

import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import dayjs from 'dayjs';
import querystring from 'query-string';

import configureStore from './store/configureStore';
import { clearError, routeChanged, clearSessionId } from './store/globals';
import {resetTicketData} from './store/tickets'
import {clearCard} from './store/cards'
import localSessionStorage from './services/localSessionStorage';
import MiddlewareRecaptcha from "./middlewares/MiddlewareRecaptcha";
//import registerServiceWorker from './registerServiceWorker';

import 'dayjs/locale/es';
dayjs.locale('es');


const tagManagerArgs = {
  gtmId: 'GTM-PCFPR5'
};
TagManager.initialize(tagManagerArgs);



const  { cinemaVistaId, showtimeVistaId } = querystring.parse(window.location.search);
const initialState = localSessionStorage.get('cccw-state');
const store = configureStore(initialState);

// Initial data
store.dispatch(routeChanged(window.location.pathname));
// clear errors if any in previous store
if (initialState.globals && initialState.globals.error !== null) {
  store.dispatch(clearError());
}

if (initialState.payments && typeof initialState.payments.paymentResponse.status_code !== 'undefined') {
  localSessionStorage.clear();
}

const render = (store, appWasRendered = false) => {
  ReactDOM.render(
    <MiddlewareRecaptcha store={store} cinemaVistaId={cinemaVistaId} showtimeVistaId={showtimeVistaId} appWasRendered={appWasRendered}/>,
    document.getElementById("root")
  );
};

// Start app
if ((Object.keys(initialState).length === 0 && initialState.constructor === Object) || 
    (showtimeVistaId && initialState.globals && initialState.globals.showtimeVistaId !== showtimeVistaId)) {
      store.dispatch(clearSessionId());
      store.dispatch(resetTicketData());
      store.dispatch(clearCard());
      render(store);
} else {
  render(store, true);
  //console.log(store.getState(), 'localSessionStorage');
}


//registerServiceWorker();
